import styled from 'styled-components';

export const StyledInputError = styled.span`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.red.R300
      : props.theme.atlas.semantic.color.action.destructive.default};
  font-size: 12px;
`;
